var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPauseIcon24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99902 12C1.99902 17.51 6.48902 22 11.999 22C17.509 22 21.999 17.51 21.999 12C21.999 6.49 17.509 2 11.999 2C6.48902 2 1.99902 6.49 1.99902 12ZM3.99902 12C3.99902 7.59 7.58902 4 11.999 4C16.409 4 19.999 7.59 19.999 12C19.999 16.41 16.409 20 11.999 20C7.58902 20 3.99902 16.41 3.99902 12ZM9.99902 17C9.44902 17 8.99902 16.55 8.99902 16V8C8.99902 7.45 9.44902 7 9.99902 7C10.549 7 10.999 7.45 10.999 8V16C10.999 16.55 10.549 17 9.99902 17ZM13.999 17C13.449 17 12.999 16.55 12.999 16V8C12.999 7.45 13.449 7 13.999 7C14.549 7 14.999 7.45 14.999 8V16C14.999 16.55 14.549 17 13.999 17Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIcon24);
export default __webpack_public_path__ + "static/media/PauseIcon-24.8f8c57f31158f00fb7fb7ea026727a94.svg";
export { ForwardRef as ReactComponent };